import { create } from 'zustand'

const STORAGE_KEY = 'topo-puzzle:admin-ui-visible'

function readStored(): boolean {
  if (typeof window === 'undefined') return true
  return window.localStorage.getItem(STORAGE_KEY) !== 'false'
}

interface AdminViewState {
  /** Whether admin-only UI (Admin nav tab, debug images, promote form) renders
   * for an admin user. Off = demo mode: the app looks like a normal account.
   * Persisted so a demo survives reloads; the /app/admin page itself stays
   * reachable by typing the URL. */
  showAdminUi: boolean
  setShowAdminUi: (visible: boolean) => void
}

export const useAdminViewStore = create<AdminViewState>((set) => ({
  showAdminUi: readStored(),
  setShowAdminUi: (visible) => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, String(visible))
    }
    set({ showAdminUi: visible })
  },
}))
